import { ENDPOINT_BASE } from "../../api";
import { normalizeCollectionResponse } from "../../api/marketplaceResponse";
import { useQueryEntities } from "../useEntityService";

export function useQuerySocialMedia() {
  const apiConfig = {
    endpoint: `${ENDPOINT_BASE.SOCIAL_MEDIA}/no-auth`,
    queryKeyLabel: "socialMedia",
    retry: 2,
    staleTime: 0,
  };

  const { data, isLoading, isError } = useQueryEntities({
    apiConfig,
  });

  return {
    data: normalizeCollectionResponse(data)[0] || {},
    isError,
    isLoading,
  };
}
